<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add store key</span>
  </a>
</ng-template>

<smart-table [headers]="headers"
             [source]="source"
             [navigate]="['edit', ':id']">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="store" let-item>
    <td>
      <entity-link type="store" [item]="item.store" [relativePath]="true"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="name" let-item>
    <td>
      {{ item.name }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>
